import type { User } from '@supabase/supabase-js';

const ALLOWED_USER_ID = '47b8a743-5048-4cca-956b-b05016903bf2';
const ALLOWED_USER_EMAIL = 'wenyonghe666@gmail.com';

type MinimalUser = Pick<User, 'id' | 'email'> | null | undefined;

/**
 * Restricts access to in-development episode features to a specific tester.
 */
export const hasEpisodeFeatureAccess = (user: MinimalUser): boolean => {
  if (!user) {
    return false;
  }

  if (user.id === ALLOWED_USER_ID) {
    return true;
  }

  const email = user.email?.toLowerCase();
  return email === ALLOWED_USER_EMAIL;
};

export { ALLOWED_USER_ID, ALLOWED_USER_EMAIL };
